/*-----------------------------------------------------------------
- Dashboard configs
-----------------------------------------------------------------*/

const dashboard = {
    nav: [
        {
            id  : 1,
            slug: 'profile',
            link: 'dashboard-profile',
            icon: {
                library: 'fa',
                prefix : 'far',
                slug   : 'user',
            },
            desktop: true,
        },
        {
            id  : 2,
            slug: 'orders',
            link: 'dashboard-orders',
            icon: {
                library: 'fa',
                prefix : 'far',
                slug   : 'file-alt',
            },
            desktop: true,
        },
        {
            id  : 3,
            slug: 'transactions',
            link: 'dashboard-transactions',
            icon: {
                library: 'fa',
                prefix : 'fas',
                slug   : 'receipt',
            },
            desktop: false,
        },
        {
            id  : 4,
            slug: 'addresses',
            link: 'dashboard-addresses',
            icon: {
                library: 'fa',
                prefix : 'fas',
                slug   : 'map-marker-alt',
            },
            desktop: false,
        },
        {
            id  : 5,
            slug: 'wishlist',
            link: 'dashboard-wishlist',
            icon: {
                library: 'fa',
                prefix : 'far',
                slug   : 'heart',
            },
            desktop: false,
        },
        {
            id  : 6,
            slug: 'change_password',
            link: 'dashboard-change-password',
            icon: {
                library: 'fa',
                prefix : 'fas',
                slug   : 'key',
            },
            desktop: false,
        },
        {
            id   : 7,
            slug : 'logout',
            link : 'home',
            query: {
                logout: '1',
            },
            icon: {
                library: 'fa',
                prefix : 'fas',
                slug   : 'sign-out-alt',
            },
            desktop: true,
        },
    ],
};

export default dashboard;
